import { isStandalone } from 'utils/environment';

/**
 * Return the VenngageE2 object from the global variable window.VenngageE2
 * Currently, there is only venngageE2, but if you need to use global vars used in e1, add it here
 * @returns {{ VenngageE2: object }} return the window.VenngageE2 object if it exists
 */
export const useVenngageE1Gate = () => {
  const venngageE2 = !isStandalone && 'VenngageE2' in window ? { ...window.VenngageE2 } : null;
  const privateLinkId = venngageE2?.privateLinkId;
  const templateCategory = venngageE2?.templateCategory?.category || '';
  const templateSubCategory = venngageE2?.templateCategory?.subcategory || '';

  return { venngageE2, templateCategory, privateLinkId, templateSubCategory };
};
